import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import eye from "../../../Components/assets/icons/eye.png";
import pen from "../../../Components/assets/icons/pen.png";
import basket from "../../../Components/assets/icons/basket.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../../assets/icons/circle.png";
import rigth from "../../assets/icons/rigth.png";
import save from "../../assets/icons/save.png";
import cancel from "../../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../Header/Header";
import { faEye } from "@fortawesome/free-solid-svg-icons";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Offcanvas from "react-bootstrap/Offcanvas";
import ViewOffCanvance from "./ViewOffCanvance";
import toast, { Toaster } from "react-hot-toast";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Context } from "../../../utils/context";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import { Deliveryboy_stage } from "../../../utils/common";
import ViewOffCanvanceOrder from "./ViewOffCanvanceOrder";
import ViewOffCanvanceReturnOrder from "./ViewOffCanvanceReturnOrder";
import AddOffCanvancePaymentDeliveryBoy from "./AddPaymentDeliveryBoy";
import AddOffCanvancePayment from "./AddPayment";

library.add(fas);

// ********************************************************************************************************************************************************

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    IMG_URL,
    postData,
  } = useContext(Context);

  const [onPageChange, setonPageChange] = useState(1);

  const [totalPages, settotalPages] = useState();

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [number, setNumber] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(0);
  const [show1, setShowEdit] = useState(0);
  const [option, setOption] = useState();
  const [searchStage, setSearchStage] = useState("");

  const [changeStatus, setChangeStatus] = useState();

  const [stage, setStage] = useState();

  const getDataAll = async () => {
    const response = await getData(
      `/delivery-boy-manegement/delivery-boy?page=${onPageChange}&per_page=${perPage}&term=${search}&searchStage=${
        searchStage?.value || ""
      }&stage=${Deliveryboy_stage.Approved}`,
    );

    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    // setNumber(response?.data?.number);
    settotalPages(response?.data?.totalPages);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
  };
  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    perPage,
    reset,
    show,
    show1,
    search,
    searchStage,
    onPageChange,
  ]);

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/employee/seller/${id}`);
    setChangeStatus(response);
  };

  // Delete module.....................................................
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  // Modal function
  const handleClose = () => setShowAdd(0);
  const handleShow = (id) => {
    setShowAdd(id);
  };

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  const DeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/employee/seller/${recordToDeleteId}`);
      await ErrorNotify(recordToDeleteName);
      setChangeStatus(response);
      setRecordToDeleteId(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
  };

  //toggle/
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [view, setview] = useState(0);
  const handleViewClose = () => setview(false);
  const handleViewshow = async (id) => {
    await setview(id);
  };

  const [viewOrder, setviewOrder] = useState(0);
  const handleViewOrderClose = () => setviewOrder(false);
  const handleViewOrdershow = async (id) => {
    await setviewOrder(id);
  };

  const [viewReturnOrder, setviewReturnOrder] = useState(0);
  const handleViewReturnOrderClose = () => setviewReturnOrder(false);
  const handleViewReturnOrdershow = async (id) => {
    await setviewReturnOrder(id);
  };
  const [showPaymentDeliveryBoy, setShowPaymentDeliveryBoy] = useState(0);
  const [showPayment, setShowPayment] = useState(0);

  const PaymentAccept = async (id, amount) => {
    try {
      // Send the POST request to update the store's status
      await postData(`/delivery-boy-manegement/delivery-boy/payment-accepted/${id}`, {
        amount: amount,
      });

      await getDataAll();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };
  return (
    <>
      <div className="main-advancedashboard">
        <Header
          title={"Approved Delivery boy"}
          link={"/employee/employee_details"}
        />
        <section className="AdvanceDashboard">
          <div className="row MainRowsec me-0 ms-0">
            <section className="Tabels tab-radio tab-radio ">
              <div className="">
                {/* container */}
                <div className="row">
                  <div className="add_info_btn_holder">
                    {/* <div className="add me-3">
                        {isAllow.includes(6) ? (
                          <Link
                            // to="/employee/employee_details/add"
                            type="button"
                            className="btn btn-add pe-3"
                          >
                            <div onClick={() => handleShow()}>
                              <img src={plus} className="plus me-2 ms-0" alt="" />
                              Add Employee
                            </div>
                          </Link>
                        ) : (
                          <></>
                        )}
                      </div> */}
                  </div>
                  <div className="border-line my-3"></div>
                  <div className="row">
                    <div className=" col-12"></div>
                    <div className=" col-12">
                      <div className="row align-ds-end">
                        {/* <div className="col-xxl-3 col-xl-3  col-lg-3  col-md-6 col-12 mt-md-0 mt-3">
                            <div className="num me-2">
                              <Select
                                options={[
                                  { value: "Requested", label: "Requests" },
                                  { value: "Rejected", label: "Rejected" },
                                ]}
                                value={searchStage}
                                placeholder="Stage"
                                onChange={(e) => {
                                  setSearchStage(e);
                                }}
                              />
                            </div>
                          </div> */}
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            placeholder="Name/Number/email"
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                              handlePageChange(1);
                            }}
                          />
                        </div>{" "}
                        {/* <div className="Search me-2">
                            <Button
                              type="button"
                             onClick={getDataAll}
                              className="btn btn-search btn btn-primary w-100"
                            >
                              <img src={search1} className="search" alt="" />
                            </Button>
                          </div> */}
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <button
                            type="button"
                            onClick={() => {
                              setSearch("");
                              setSearchStage("");
                              setReset(!reset);
                            }}
                            className="btn btn-reset "
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-line mt-3"></div>
                <div className="row mt-4 me-0 ms-0">
                  <div className="data table-responsive">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr className="">
                          {visible.col1 && <th className="sr">Sr. No.</th>}

                          {visible.col3 && (
                            <th className="tax-name" style={{ width: "900px" }}>
                              Name
                            </th>
                          )}
                          {visible.col4 && (
                            <th className="tax-name" style={{ width: "900px" }}>
                              Email
                            </th>
                          )}
                          {/* {visible.col10 && (
                              <th className="tax-name" style={{ width: "900px" }}>logo</th>
                            )} */}
                          {visible.col5 && (
                            <th className="tax-name" style={{ width: "900px" }}>
                              Mobile No
                            </th>
                          )}
                          {/* {visible.col6 && (
                              <th
                                className="tax-name"
                                style={{ width: "900px" }}
                              >
                                Delivery boy Email
                              </th>
                            )} */}
                          {/* {visible.col9 && (
                              <th className="tax-name" style={{ width: "900px" }}>Commission %</th>
                            )} */}
                          {/* {visible.col6 && (
                            <th className="tax-name">Password</th>
                          )} */}
                          {/* {visible.col7 && <th className="tax-name" style={{ width: "900px" }}>Status</th>} */}
                          {visible.col8 && (
                            <th className="tax-name" style={{ width: "900px" }}>
                              Action
                            </th>
                          )}

                          <th>Payment Receive</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* {isAllow.includes(5) ? ( */}
                        {data?.data?.data?.length > 0 ? (
                          data.data.data.map((d, index) => {
                            const paginatedIndex =
                              (onPageChange - 1) * perPage + index + 1;
                            return (
                              <tr className="" key={index}>
                                {visible.col1 && <td>{paginatedIndex}.</td>}{" "}
                                {visible.col3 && <td>{d?.first_name}</td>}
                                {visible.col4 && <td>{d?.email}</td>}
                                {visible.col5 && <td>{d?.contact_no}</td>}
                                {visible.col8 && (
                                  <td>
                                    <div className="d-flex">
                                      <div className="add me-3">
                                        {" "}
                                        <Link
                                          type="button"
                                          className="btn btn-add pe-3"
                                        >
                                          <div
                                            onClick={() => handleViewshow(d.id)}
                                          >
                                            view
                                          </div>
                                        </Link>
                                      </div>

                                      <div className="add me-3">
                                        {" "}
                                        <Link
                                          type="button"
                                          className="btn btn-add pe-3"
                                        >
                                          <div
                                            onClick={() =>
                                              handleViewOrdershow(d.id)
                                            }
                                          >
                                            view Order
                                          </div>
                                        </Link>
                                      </div>
                                      <div className="add me-3">
                                        {" "}
                                        <Link
                                          type="button"
                                          className="btn btn-add pe-3"
                                        >
                                          <div
                                            onClick={() =>
                                              handleViewReturnOrdershow(d.id)
                                            }
                                          >
                                            View Return Order
                                          </div>
                                        </Link>
                                      </div>
                                    </div>
                                  </td>
                                )}
                                {visible.col5 && (
                                  <td>
                                    <div>
                                      <div>
                                        <div>
                                          Total Payment: ₹
                                          {d?.orders_details
                                            ? d.orders_details
                                                .reduce(
                                                  (sum, collect) =>
                                                    sum +
                                                    parseFloat(
                                                      collect.total_amount || 0,
                                                    ),
                                                  0,
                                                )
                                                .toFixed(2)
                                            : "0.00"}
                                        </div>
                                      </div>

                                         {d?.orders_details &&
                                        d.orders_details.reduce(
                                          (sum, collect) =>
                                            sum +
                                            parseFloat(
                                              collect.total_amount || 0,
                                            ),
                                          0,
                                        ) > 0 && (
                                          <Button
                                            className="btn-primary"
                                            onClick={() => {
                                              const totalAmount =
                                                d.orders_details
                                                  .reduce(
                                                    (sum, collect) =>
                                                      sum +
                                                      parseFloat(
                                                        collect.total_amount ||
                                                          0,
                                                      ),
                                                    0,
                                                  )
                                                  .toFixed(2);

                                              if (
                                                window.confirm(
                                                  `Do you want to confirm payment of ₹${totalAmount}?`,
                                                )
                                              ) {
                                                PaymentAccept(
                                                  d?.id,
                                                  totalAmount,
                                                );
                                              }
                                            }}
                                            style={{ marginTop: "10px" }}
                                          >
                                             Receive Payment From Delivery Boy
                                          </Button>
                                        )}

                                      <div>
                                        <Button
                                          className="btn-primary "
                                          onClick={() =>
                                            setShowPaymentDeliveryBoy(d?.id)
                                          }
                                          style={{ marginTop: "10px" }}
                                        >
                                          Payment Give Delivery Boy
                                        </Button>
                                      </div>

                                   
                                    </div>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center">
                              Data not available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>{" "}
                    <Pagination_Holder
                      onPageChange={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <Toaster position="top-right" />

      {/* <!-- Modal Delete --> */}
      <div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button className="btn btn-yes me-2" onClick={DeleteRecord}>
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {view ? (
        <ViewOffCanvance
          handleClose={handleViewClose}
          setShow={setview}
          show={view}
          id={view}
        />
      ) : (
        ""
      )}

      {viewOrder ? (
        <ViewOffCanvanceOrder
          handleClose={handleViewOrderClose}
          setShow={setviewOrder}
          show={viewOrder}
          id={viewOrder}
        />
      ) : (
        ""
      )}

      {viewReturnOrder ? (
        <ViewOffCanvanceReturnOrder
          handleClose={handleViewReturnOrderClose}
          setShow={setviewReturnOrder}
          show={viewReturnOrder}
          id={viewReturnOrder}
        />
      ) : (
        ""
      )}

      <AddOffCanvancePaymentDeliveryBoy
        show={showPaymentDeliveryBoy}
        handleClose={() => setShowPaymentDeliveryBoy(0)}
      />
      <AddOffCanvancePayment
        show={showPayment}
        handleClose={() => setShowPayment(0)}
      />
    </>
  );
};

export default Tables;
